export default __webpack_public_path__ + "45d018d971814056a4bcdbd4f022a5a8.png";